<template>
  <div>
    <AppHeader  class="bg-header" fixed > 
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" :src="`${$store.state.app_url}/img/logo_orange.png`" width="45" height="45" alt="Logo Orange">
      </b-link>
      <b-navbar-nav class="ml-auto">
          <b-nav-item color="#ffff" class="d-md-down-none menu-item" @click="$router.push('/pages/home')" >
          <b-link class="text-white">
            <i class="icon-home"></i>
              Accueil
            </b-link>
          </b-nav-item>

            <b-nav-item v-if="$store.getters.isAuthenticated" color="#ffff" class="d-md-down-none menu-item" @click="$router.push('/mon-dossier')">
          <b-link class="text-white">
            <i class="fa fa-folder"></i>
              Mon Dossier
            </b-link>
          </b-nav-item>

        <b-nav-item v-if="!$store.getters.isAuthenticated" class="d-md-down-none menu-item" @click="$router.push('/pages/login')" >
          <b-link class="text-white">
            <i class="icon-login"></i>
            Se connecter
          </b-link>
        </b-nav-item>
      
        <b-nav-item v-if="!$store.getters.isAuthenticated" class="d-md-down-none menu-item" @click="$router.push('/pages/register')" >
          <b-link class="text-white">
            <i class="icon-register"></i>
            S'inscrire
          </b-link>
        </b-nav-item>
        <DefaultHeaderDropdownAccnt v-if="$store.getters.isAuthenticated"/>
      </b-navbar-nav>

    </AppHeader>

    <SidebarToggler class="d-lg-down-none"  display="md" :defaultOpen="false"/>

    <nav display="sm" class="sidebar-nav">
      <AppSidebar class="bg-org " fixed>
        <nav>
          <VuePerfectScrollbar class="scroll-area"/>
          <ul style="list-style-type:none">
            <SidebarNavItem >
                <SidebarNavLink  name="" url="#" icon="" />
            </SidebarNavItem>
            
            <template v-for="(item,index) in tnav">
              <SidebarNavItem :key="index" :classes="item.class">
                <SidebarNavLink  :name="item.name" :url="item.url" :icon="item.icon" :variant="item.variant"/>
              </SidebarNavItem>
            </template>
          </ul>
        </nav>
      </AppSidebar>
    </nav>
  </div>
</template>

<script>
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar,  SidebarMinimizer, AsideToggler, SidebarNavItem, SidebarNavLink } from '@coreui/vue'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import tnav from '@/unauth/_nav'
import nav from '@/_nav'


export default {
  name: 'app-header',
  components: {
    AppHeader,
    AppSidebar,
    DefaultHeaderDropdownAccnt,
    SidebarToggler,
    SidebarMinimizer,
    SidebarNavItem,
    SidebarNavLink,
    VuePerfectScrollbar
  },
  mounted(){
    console.log('tnav',tnav);
  },
  computed:{
    tnav:()=>tnav.items
  },

}
</script>

<style>
.menu-item{
  padding: 20px
}

.scroll-area{
  position: absolute;
  height: 100%;
  margin: auto;
}
</style>
